import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';

type Theme = 'light' | 'dark';
const STORAGE_KEY = 'tembiapo:theme';

/** Lee el tema guardado o lo deriva de prefers-color-scheme. */
function initialTheme(): Theme | null {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved === 'light' || saved === 'dark' ? saved : null;
}

/**
 * Toggle claro/oscuro. Setea data-theme en <html> (los tokens de tokens.css
 * reaccionan a data-theme; sin data-theme, cae a prefers-color-scheme).
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme | null>(initialTheme);

  useEffect(() => {
    const root = document.documentElement;
    if (theme) {
      root.setAttribute('data-theme', theme);
      localStorage.setItem(STORAGE_KEY, theme);
    } else {
      root.removeAttribute('data-theme');
    }
  }, [theme]);

  const isDark =
    theme === 'dark' ||
    (theme === null && window.matchMedia('(prefers-color-scheme: dark)').matches);

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label={isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
      className="inline-flex h-9 w-9 items-center justify-center rounded-token border border-line bg-surface-2 text-ink hover:text-brand transition-colors"
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
